import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { Video, ArrowRight, Calendar, CheckCircle2 } from "lucide-react";
import { fmtDate, pretty } from "./referralConstants";

const TONE = {
  scheduled: "#2563EB", waiting: "#B7791F", active: "#2F7D5A", completed: "#6B7280",
};

export default function ExternalMeetings() {
  const nav = useNavigate();
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/external/meetings").then(({ data }) => setData(data)).catch(() => setData({ items: [] })); }, []);
  if (!data) return <div className="space-y-3"><Skeleton className="h-10" /><Skeleton className="h-24" /><Skeleton className="h-24" /></div>;
  const items = data.items || [];

  return (
    <div data-testid="external-meetings-page" className="space-y-5">
      <div className="flex items-center gap-2">
        <Video size={22} className="text-[#1C4358]" />
        <h1 className="font-display text-2xl font-bold text-[#252221]">Meetings</h1>
        <span className="text-[13px] text-muted-foreground">{data.upcoming || 0} upcoming</span>
      </div>

      {items.length === 0 ? (
        <Card className="p-10 border-[#E6EDF2] text-center" data-testid="external-meetings-empty">
          <span className="mx-auto h-12 w-12 rounded-2xl bg-[#1C4358]/10 text-[#1C4358] flex items-center justify-center"><Video size={22} /></span>
          <p className="text-[15px] text-muted-foreground mt-3">No meetings yet. Meetings you're invited to by MovingMyMama will appear here.</p>
        </Card>
      ) : (
        <div className="space-y-3">
          {items.map((m) => (
            <button key={m.id} onClick={() => nav(`/external/meetings/${m.id}`)} data-testid={`external-meeting-card-${m.id}`}
              className="w-full text-left rounded-xl bg-white border border-[#E6EDF2] p-4 hover:border-[#1C4358]/40 hover:shadow-sm transition-all">
              <div className="flex items-start justify-between gap-2">
                <div className="min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="text-[11px] font-bold px-2 py-0.5 rounded-full" style={{ backgroundColor: `${TONE[m.status] || "#6B7280"}22`, color: TONE[m.status] || "#6B7280" }}>{m.status_label || pretty(m.status)}</span>
                    <span className="text-[13px] font-semibold text-[#1C4358]">{m.meeting_type_label || "Meeting"}</span>
                    {m.prep_complete && <span className="text-[11px] text-[#2F7D5A] font-semibold flex items-center gap-0.5"><CheckCircle2 size={11} /> Prep done</span>}
                  </div>
                  <p className="text-[14px] font-medium text-[#252221] mt-1.5">{m.title}</p>
                  {m.scheduled_at && <div className="text-[12px] text-[#4B5563] mt-1 flex items-center gap-1"><Calendar size={12} /> {fmtDate(m.scheduled_at)}</div>}
                </div>
                <ArrowRight size={18} className="text-[#9AA5B1] shrink-0 mt-1" />
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
